import http from "../../axios";

const AdminService = (() => {
  const fetchAdmins = async () => {
    const res = await http.get(`/sbc/admins`);
    return res.data;
  };

  const createAdmin = async (data) => {
    const res = await http.post(`/sbc/admins`, data);
    return res.data;
  };
  const getAdmin = async (id) => {
    const res = await http.get(`/sbc/admins/${id}`);
    return res.data;
  };
  const updateAdmin = async (id, data) => {
    const res = await http.put(`/sbc/admins/${id}`, data);
    return res.data;
  };
  const deleteAdmin = async (id) => {
    const res = await http.delete(`/sbc/admins/${id}`);
    return res.data;
  };

  return {
    fetchAdmins,
    createAdmin,
    getAdmin,
    updateAdmin,
    deleteAdmin,
  };
})();

export default AdminService;
